import { format } from "date-fns";
import { StaffTaskFormValues } from "./staff-task-form.component";
import { StaffTask } from "services/types/staff-tasks.type";
import { CurrentUser } from "features/auth/auth-slice";
import { formatBackendDateOnly } from "utils/common";

export const formatStaffTaskToInput = (data: StaffTaskFormValues) => {
  return {
    id: data.id,
    title: data.title,
    description: data.description,
    assignee: data.assignee?.value ? Number(data.assignee?.value) : null,
    assignees: data.assignees
      .filter((assignee) => assignee.value !== data.assignee?.value)
      .map((assignee) => ({
        user: Number(assignee.value),
      })),
    due_at: data.due_at
      ? format(new Date(data.due_at), "yyyy-MM-dd'T'HH:mm:ss")
      : null,
    patient: data.patient?.id,
  };
};

export const getInitialValues = (
  editMode: StaffTask | undefined,
  currentUser: CurrentUser
): StaffTaskFormValues => {
  if (editMode) {
    return {
      id: editMode?.id,
      title: editMode?.title ?? "",
      description: editMode?.description ?? "",
      due_at: editMode?.due_at
        ? formatBackendDateOnly(editMode?.due_at, "MM/dd/yyyy")
        : "",
      assignee: editMode?.assignee
        ? {
            label: String(editMode?.assignee?.fullName),
            value: String(editMode?.assignee.id),
          }
        : null,
      assignees: editMode?.assignees
        ? editMode?.assignees.map((assignee) => ({
            label: String(assignee.user?.fullName),
            value: String(assignee.user?.id),
          }))
        : [],
      patient: editMode?.patient,
    };
  }

  return {
    title: "",
    description: "",
    due_at: null,
    assignee: { label: currentUser.fullName, value: String(currentUser.id) },
    assignees: [],
    patient: null,
  };
};
